import {WelcomeHeader} from "../components/Header/WelcomeHeader";
import {WelcomeSlider} from "../components/Slider/WelcomeSlider";
import "../assets/styles/pages/home.scss"
import {ForgotPasswordForm} from "../components/Form/ForgotPasswordForm";

export const SignUp = () => {
    return (
        <div>
            <WelcomeHeader />

            <div className="home grid-50">

                <WelcomeSlider />

                <ForgotPasswordForm
                    title='Enter your email below to create your password for the Atlantic-Oase Rewards Program.'
                    showSignUp={false}
                />

            </div>
        </div>
    )
}
